import { Box, Typography } from '@mui/material'
import clsx from 'clsx';
import React from 'react'
import { useTranslation } from 'react-i18next';

type Props = {
    title: string;
    between_title?: React.ReactNode;
    subTitle?: string | React.ReactNode;
    content?: React.ReactNode;
    hidden_sub_title?: boolean;
    sub_title_custom?: React.ReactNode;
    navigateContent?: React.ReactNode;
    topRightContentClassName?: string;
    topRightContent?: React.ReactNode;
    buttonContent?: React.ReactNode;
    titleName?: string;
    enablePadding?: boolean;
}

const ContainerLayout: React.FC<Props> = (props) => {
    const { t } = useTranslation();
    const { enablePadding } = props;
    return (
        <div className='w-full flex justify-start flex-col gap-2 items-start'>
            {props.navigateContent && props.buttonContent ? (
                <div className='w-full flex gap-4 flex-wrap'>
                    <span>
                        {props.navigateContent}
                    </span>
                    <span className='flex-1 flex justify-end items-end w-full'>
                        {props.buttonContent}
                    </span>

                </div>
            ) : (
                <>
                    {props.navigateContent}
                </>
            )}
            <Box className={props.between_title ? "d-flex flex-column mt-4 w-full" : "d-flex flex-column mt-4"}>
                <span className='flex w-full justify-between items-center gap-4 flex-col md:flex-row'>
                    <Typography variant='h3'>
                        {props.title || props.titleName}
                    </Typography>
                    {props.between_title}
                </span>
                {props.sub_title_custom}
            </Box>
            {!props.hidden_sub_title && (
                <span>
                    <Typography>
                        {props.subTitle || t("HEADING.SELECT_LIST")}
                    </Typography>
                </span>
            )}

            <div className={clsx('mt-4 w-full', {
                'px-[1rem] md:px-[10rem]': enablePadding
            })}>
                {props.content}
            </div>
        </div>
    )
}

export default ContainerLayout